import React, { useState } from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";


// const useStyles = makeStyles({
//   textfield: {
//     "& input[type=number]": {
//       "-moz-appearance": "textfield",
//     },
//     "& input[type=number]::-webkit-outer-spin-button": {
//       "-webkit-appearance": "none",
//       margin: 0,
//     },
//     "& input[type=number]::-webkit-inner-spin-button": {
//       "-webkit-appearance": "none",
//       margin: 0,
//     },
//   },
// });
export default function BasicTextfield({
  label = "",
  fullWidth = false,
  is_phone = false,
  handleChange = () => {},
  is_disabled = false,
  index = 0,
  error = false,
  helperText = "",
  required = false,
  value = "",
  number = false,
  unit = "",
  borderRadius = "1rem",
  is_password = false,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const blockInvalidCharNumber = (e) => {
    (["e", "E", "+", "-", "."].includes(e.key) ||
      e.which === 38 ||
      e.which === 40) &&
      e.preventDefault();
  };
  const blockInvalidChar = (e) =>
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  // const classes = useStyles();
  return (
    <TextField
    type={number === true ? "number" : is_password ? (showPassword ? "text" : "password") : "string"}
        label={value === "" ? label : undefined}
      key={index}
      disabled={is_disabled}
      required={required}
      error={error}
      helperText={helperText}
      value={value}
      variant="outlined"
      // className={classes.textfield}
      sx={{
        width: fullWidth ? "100%" : "90%",
        backgroundColor: "#FFFFFF",
        borderRadius: "1rem",
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: "1rem",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderRadius: "1rem",
        },
      }}
      inputProps={{
        maxLength: 40,
        style: {
          height: "40%",
          borderRadius: borderRadius,
        },
        "aria-label": "Without label",
      }}
      InputProps={{
        startAdornment: is_phone && (
          <InputAdornment position="start">
            <p>+91 | </p>
          </InputAdornment>
        ),
        endAdornment: (
          <>
            {unit !== "" && (
              <InputAdornment position="end">{unit}</InputAdornment>
            )}
            {is_password && (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleTogglePasswordVisibility}
                  edge="end"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            )}
          </>        ),
      }}
      onChange={(e) => handleChange(e.target.value, index)}
    />
  );
}
